import React from 'react'
import { Button, Tooltip } from '@mui/material'
import { useSmartTranslation } from '../../../../generic/hooks/useSmartTranslation'

/**
 * Story 100 (S103, RN33/POL1/POL2 + RN14 lectura A): the widget is the ONLY place these actions
 * live (RN33). Derived purely from the row's own dates, no separate "population" flag needed:
 *  - no actual return AND no actual dispatch -> PENDING: offer Dispatch, disabled with a reason
 *    when `row.dispatchEnabled` is false (the reason comes from Sun -- POL4.1-style verbatim text,
 *    the same wording as E-M1 `PreviousStepNotCompleted`, never reconstructed in Jupiter).
 *  - actual dispatch present, no actual return -> DISPATCHED: offer Return, and ONLY Return.
 *  - actual return present -> RETURNED: no action at all (S105: it is history).
 *
 * The tooltip lives on the wrapping span (a disabled MUI button fires no mouse events), same
 * pattern as #86/S60+S62.
 */
const ExternalJobRowActions = ({ row, onDispatch = () => {}, onReturn = () => {} }) => {
  const { t_ } = useSmartTranslation()

  if (row.actualReturn) {
    return null
  }

  if (row.actualDispatch) {
    return (
      <Button variant='outlined' size='small' onClick={() => onReturn(row)}>
        {t_('Return')}
      </Button>
    )
  }

  const disabled = row.dispatchEnabled === false
  const button = (
    <Button variant='outlined' size='small' disabled={disabled} onClick={() => onDispatch(row)}>
      {t_('Dispatch')}
    </Button>
  )

  if (!disabled) {
    return button
  }

  return (
    <Tooltip title={row.dispatchDisabledReason ?? t_('Waiting for the previous step to be completed')}>
      <span>{button}</span>
    </Tooltip>
  )
}

export default ExternalJobRowActions
